export default function Card69(){
    return (
        <div>
            {/*<div className={"text-4xl p-8 bg-gradient-to-r from-indigo-200 via-purple-200 to-pink-200"}>*/}
            {/*    <div className={"text-center font-bold"}>Card 69 :</div>*/}
            {/*</div>*/}
            <div class="max-w-6xl px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
                <div class="grid sm:grid-cols-12 gap-6">
                    <div class="sm:self-end col-span-12 sm:col-span-7 md:col-span-8 lg:col-span-5 lg:col-start-3">
                        <div class="group relative block rounded-xl overflow-hidden dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="#">
                            <div class="rounded-xl overflow-hidden">
                                <img class="aspect-video sm:aspect-auto group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl w-full object-cover opacity-50" src="https://dummyimage.com/340x220" alt="Description"/>
                            </div>
                            <div class="absolute bottom-0 start-0 end-0 p-2 sm:p-4">
                                <div class="text-sm font-bold text-gray-800 rounded-lg bg-white p-4 md:text-xl dark:bg-gray-800 dark:text-gray-200">
                                    Workplace personalities
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="sm:self-end col-span-12 sm:col-span-5 md:col-span-4 lg:col-span-3">
                        <div class="group relative block rounded-xl overflow-hidden dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="#">
                            <div class="rounded-xl overflow-hidden">
                                <img class="aspect-video sm:aspect-auto group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl w-full object-cover opacity-50" src="https://dummyimage.com/250x380" alt="Description"/>
                            </div>
                            <div class="absolute bottom-0 start-0 end-0 p-2 sm:p-4">
                                <div class="text-sm font-bold text-gray-800 rounded-lg bg-white p-4 md:text-xl dark:bg-gray-800 dark:text-gray-200">
                                    Women in engineering
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-span-12 md:col-span-4">
                        <div class="group relative block rounded-xl overflow-hidden dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="#">
                            <div class="rounded-xl overflow-hidden">
                                <img class="aspect-video sm:aspect-auto group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl w-full object-cover opacity-50" src="https://dummyimage.com/350x230" alt="Description"/>
                            </div>
                            <div class="absolute bottom-0 start-0 end-0 p-2 sm:p-4">
                                <div class="text-sm font-bold text-gray-800 rounded-lg bg-white p-4 md:text-xl dark:bg-gray-800 dark:text-gray-200">
                                    Pride 2021
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-span-12 sm:col-span-6 md:col-span-4">
                        <div class="group relative block rounded-xl overflow-hidden dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="#">
                            <div class="rounded-xl overflow-hidden">
                                <img class="aspect-video sm:aspect-auto group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl w-full object-cover opacity-50" src="https://dummyimage.com/350x460" alt="Description"/>
                            </div>
                            <div class="absolute bottom-0 start-0 end-0 p-2 sm:p-4">
                                <div class="text-sm font-bold text-gray-800 rounded-lg bg-white p-4 md:text-xl dark:bg-gray-800 dark:text-gray-200">
                                    Data at Preline
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-span-12 sm:col-span-6 md:col-span-4">
                        <div class="group relative block rounded-xl overflow-hidden dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="#">
                            <div class="rounded-xl overflow-hidden">
                                <img class="aspect-video sm:aspect-auto group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl w-full object-cover opacity-50" src="https://dummyimage.com/400x400" alt="Description"/>
                            </div>
                            <div class="absolute bottom-0 start-0 end-0 p-2 sm:p-4">
                                <div class="text-sm font-bold text-gray-800 rounded-lg bg-white p-4 md:text-xl dark:bg-gray-800 dark:text-gray-200">
                                    Empowered management
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}